<template>
  <div class="min-h-screen flex flex-col items-center justify-center p-8 text-center bg-white relative">
    <div class="w-24 h-24 bg-primary/20 rounded-full flex items-center justify-center mb-6 text-4xl">
      👶
    </div>
    <h1 class="text-2xl font-bold mb-2 text-textMain">寶寶疫苗小幫手</h1>
    <p class="text-textMuted text-sm mb-12">為您的寶貝規劃完整的健康防護網</p>
    
    <div class="bg-gray-50 p-4 rounded-xl text-left text-xs text-textMuted mb-8 leading-relaxed border border-gray-100">
      <p class="font-bold mb-2 text-accent">免責聲明</p>
      <p>本應用程式依據衛福部疾管署公開資訊整理，提供 0–6 歲兒童常規預防接種時程之提醒功能。本應用程式提供之疫苗接種時程、疫苗用途、及接種後可能出現之反應，均依據衛生福利部疾管署及其他政府公開資料整理。所有資訊僅供使用者一般性參考，並不構成醫療建議或診斷。
實際接種時間、疫苗種類及是否適合接種，應由具醫療資格之專業人員評估。如使用者或其子女出現任何不適症狀，應立即洽詢醫療院所。</p>
    </div>

    <button @click="agree" class="w-full bg-accent text-white font-bold py-3 rounded-2xl shadow-lg shadow-accent/30 active:scale-95 transition-transform">
      我了解並同意
    </button>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useAppStore } from '../stores/useAppStore';

const router = useRouter();
const store = useAppStore();

const agree = () => {
  // 只跳轉到建立寶寶頁面，不設置 hasOnboarded
  // hasOnboarded 會在用戶真正建立寶寶後才設置
  router.push('/create');
};
</script>